import mobx, { observable, action, computed, autorun } from 'mobx';
import _ from 'lodash';
import api from '../../api';

export default class HistoryPage {
	@observable data = null;
	@observable isLoading = true;
	@observable wait = false;
	@observable filter = null;
	@observable date = 30;
	@observable result = {
		status: 0,
		text: '',
		type: 0
	};

	constructor(store, data) {
		this.store = store;
		this.getData();
	}

	@action getData() {
		return api.user.getHistoryData().then(
				action(
					res => {
						if (res.code == 'OK') {
							this.filter = res.result;
							this.date = res.result.default.date;
							this.loadData(this.date);
						} else {
							this.setResult(res.text ? res.text : 'SERVER_TEMPORARILY_DOWN');
						}
					}
				)
			)
			.catch(action(err => {
        this.setResult('SERVER_TEMPORARILY_DOWN');
      }))
      .finally(action(() => { this.isLoading = false; }));
	}

	@action selectDate(date) {
		this.date = date;
	}

	@action setResult(text, type = 0) {
		this.result.status = 1;
		this.result.text = text;
		this.result.type = type;
	}

	@action clear() {
		this.result.status = 0;
		this.result.text = '';
		this.result.type = 0;
	}

	@action loadData(date) {
		this.wait = true;
		this.clear();
		const data = {
			date : this.date
		}
		return api.user.getHistory(data).then(
				action(
					res => {
						if (res.code == 'OK') {
							this.data = res.result;
						} else {
							this.setResult(res.text ? res.text : 'SERVER_TEMPORARILY_DOWN');
						}
					}
				)
			)
			.catch(action(err => {
        this.setResult('SERVER_TEMPORARILY_DOWN');
      }))
      .finally(action(() => { this.wait = false; }));
	}

	@action cancel(id) {
		this.clear();
		const data = {
			action : 'cancel',
			id : id
		}
		return api.user.setCancel(data).then(
				action(
					res => {
						if (res.code == 'OK') {
							this.setResult(res.text, 1);
							const indx = this.data.findIndex(item => item == id);
							this.data[indx].allow_cancel = 0;
							this.data[indx].status = id;
						} else {
							this.setResult(res.text ? res.text : 'SERVER_TEMPORARILY_DOWN');
						}
					}
				)
			)
			.catch(action(err => {
        this.setResult('SERVER_TEMPORARILY_DOWN');
      }))
	}

}


// WEBPACK FOOTER //
// ./src/stores/accountStore/history.js